import { render, staticRenderFns } from "./AudioTranscriptDummy.vue?vue&type=template&id=d97380d8&scoped=true&"
import script from "./AudioTranscriptDummy.vue?vue&type=script&lang=js&"
export * from "./AudioTranscriptDummy.vue?vue&type=script&lang=js&"
import style0 from "./AudioTranscriptDummy.vue?vue&type=style&index=0&id=d97380d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97380d8",
  null
  
)

export default component.exports